import {
  GenericLoginPrompt,
  ImageBanner,
  type LoginPromptProps as GenericLoginPromptProps,
} from '@ts-internal/shared-lib';
import { useTranslations } from '@vocab/react';

import translations from './.vocab';
import imageUrl from './images/market-image.jpg';

export interface LoginPromptProps {
  loginUrl: string;
  googleLoginUrl: string;
  registerUrl: string;
  trackingCallbacks: GenericLoginPromptProps['trackingCallbacks'];
}

export const LoginPrompt = ({
  loginUrl,
  registerUrl,
  googleLoginUrl,
  trackingCallbacks,
}: LoginPromptProps) => {
  const { t } = useTranslations(translations);

  return (
    <ImageBanner imageUrl={imageUrl}>
      <GenericLoginPrompt
        loginUrl={loginUrl}
        registerUrl={registerUrl}
        googleLoginUrl={googleLoginUrl}
        headingText={t('SIGN_IN_TO_SEE_MORE')}
        loginBulletPoints={[
          t('UNLOCK_PROFILE_DETAILS_SKILLS_AND_FILTERS'),
          t('CHECK_VERIFIED_CREDENTIALS'),
          t('BROWSE_AND_COMPARE_PROFILES'),
        ]}
        alignContent="left"
        trackingCallbacks={trackingCallbacks}
      />
    </ImageBanner>
  );
};
